import { OrderLine } from '../../orders/types';
import { Return, ReturnInfos, ReturnLine } from '../types';

type ReturnCart = Record<string, Record<string, ReturnLine & OrderLine & ReturnInfos>>;

export type ReturnSubmitPayload = Pick<Return, 'clientId' | 'orderId' | 'items'>;

export const buildReturnPayloadFromCartKey = (
  returnOrderLines: ReturnCart,
  cartKey: string,
): ReturnSubmitPayload | null => {
  const lines = returnOrderLines[cartKey];
  if (!lines || Object.keys(lines).length === 0) {
    return null;
  }

  const [clientId, orderId] = cartKey.split('/');

  return {
    clientId: clientId !== 'undefined' ? clientId : '',
    orderId: orderId !== 'undefined' ? orderId : '',
    items: Object.values(lines).map((item) => ({
      cact: item.cact === 'REM' ? 'ERM' : item.cact,
      qret: String(item.qret),
      clit: item.clit,
      nart: item.nart,
      desi: item.desi,
      ...(item.size ? { size: item.size } : {}),
      ...(item.new_nart ? { new_nart: item.new_nart } : {}),
    })),
  };
};

export const buildReturnPayloadForOrder = (
  returnOrderLines: ReturnCart,
  clientId?: string,
  orderId?: string,
): ReturnSubmitPayload | null => {
  if (!clientId || !orderId) {
    return null;
  }
  return buildReturnPayloadFromCartKey(returnOrderLines, `${clientId}/${orderId}`);
};
